import { assert } from '@ember/debug';
import { DataType } from '@square/ember-features/protos/squareup/feature/relay/common/data_type';
import MacroServiceWrapper from '../~private/macro-service-wrapper';
/**
 * Computed property macro for checking a feature flag (similar to `computed.readOnly` from Ember).
 * @param {string} flag to check
 * @returns {FlagValues} value of the feature flag
 */
export default function feature(...flags) {
  assert('this macro only takes one feature flag as an argument', flags.length === 1);
  const flag = flags[0];
  const dependentKeys = [`_flags.${flag}`];
  return MacroServiceWrapper(featuresServiceParam => {
    const flagValue = featuresServiceParam.getFlag(flag);
    const flagType = featuresServiceParam.getFlagType(flag);
    switch (flagType) {
      case DataType.INTEGER:
      case DataType.DOUBLE:
        return flagValue || 0;
      case DataType.STRING:
        return flagValue || '';
      case DataType.JSON:
        return flagValue || undefined;
      case DataType.BOOLEAN:
      default:
        return flagValue || false;
    }
  }, dependentKeys);
}